import { api } from "../client";
import { endpoints } from "../endpoints";

export const examService = {
  /** @returns {Promise<import("../generated/migration").components["schemas"]["ExamSnapshot"] | {success: boolean}>} */
  async flow(id, action = "conf", data, signal) {
    const result = await api.request({ url: endpoints.exams.flow(id, action),
      method: action === "return" ? "POST" : "GET", data, signal });
    return result.data;
  },
  async answer(id, aqn, answer_number, signal) {
    return api.request({ url: endpoints.exams.choice(id, answer_number == null ? "rem" : "set"),
      method: "POST", data: answer_number == null ? { aqn } : { aqn, answer_number }, signal });
  },
};
const messages = {
  "Exam Finished": "آزمون پایان یافته است یا در آن حضور نداشته‌اید.",
  "Exam time over": "مهلت آزمون گذشته است. پایان آزمون را ثبت کنید.",
  "No returns left": "بازگشتی باقی نمانده است.",
  "Can only answer the active question": "فقط پاسخ سؤال فعال قابل ثبت است.",
  "Can only return to an earlier question": "فقط به سؤال‌های قبلی می‌توانید برگردید.",
  "Invalid question number": "شماره سؤال معتبر نیست.",
  "Invalid action": "عملیات آزمون معتبر نیست.",
  "Invalid parameters": "اطلاعات پاسخ معتبر نیست. دوباره همگام‌سازی کنید.",
  "Invalid command": "عملیات ثبت پاسخ معتبر نیست.",
  "No questions": "سؤالی برای این آزمون ثبت نشده است.",
  "You are not allowed": "شما در این آزمون ثبت نشده‌اید.",
};
export function examError(error) {
  const raw = error.data?.message || error.data?.detail || error.data?.error || error.data;
  return messages[raw] || error.message;
}
export function questionImage(value) {
  if (!value || typeof value !== "string") return null;
  try {
    const url = new URL(value, process.env.REACT_APP_API_URL + "/");
    return ["https:", "http:"].includes(url.protocol) ? url.href : null;
  } catch { return null; }
}
